
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef } from 'react';
import { Button, Card, Container, FloatingLabel, Form } from 'react-bootstrap';
import { useSendEmailVerification, useSendPasswordResetEmail, useSignInWithEmailAndPassword, useSignInWithGoogle } from 'react-firebase-hooks/auth';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import auth from '../../firebase';
import Loading from '../../Shared/Loading/Loading';
import './Login.css';
const Login = () => {
    const emailRef = useRef('');
    const passwordRef = useRef('');
    
    const navigate = useNavigate();
    const [signInWithEmailAndPassword,user,loading,error,] = useSignInWithEmailAndPassword(auth);
      const [signInWithGoogle, user1, loading1] = useSignInWithGoogle(auth);
      const [sendEmailVerification, sending] = useSendEmailVerification(auth);
      const [sendPasswordResetEmail, sending1,] = useSendPasswordResetEmail(auth);

    if(loading || loading1 || sending || sending1){
        return <Loading/>;
    }
    if(user || user1){
        navigate('/')
    }
    const handleSubmit = async (e)=> {
        e.preventDefault();
        const email = emailRef.current.value;
        const password = passwordRef.current.value;
        if(email && password){
            await sendEmailVerification();
            toast.success('Sent email');
            signInWithEmailAndPassword(email,password);
        }
    }
    const resetPassword = (e) =>{ 
        e.preventDefault();
        const email = emailRef.current.value;
        if(email){
            sendPasswordResetEmail(email);
            toast.success('Sent email');
            navigate('/')
        } else{
            toast.warning('Please Enter Your Email Address');
        } 
    }
    return (
        <div className='login'>
            <Container style={{minHeight:'90vh'}} className='d-flex align-items-center justify-content-center'>
                <div className='w-100' style={{maxWidth:'600px'}}>
                        <Card style={{maxWidth:'450px'}} className='p-2 mx-auto'>
                            <Card.Body>
                                <Card.Title>
                                    <h3>Login</h3>
                                </Card.Title>
                                <Form onSubmit={handleSubmit} className='my-5'>
                                    <FloatingLabel
                                        controlId="formBasicEmail"
                                        label="Email address"
                                        className="mb-3"
                                    >
                                        <Form.Control ref={emailRef} type="email" placeholder="name@example.com" />
                                    </FloatingLabel>
                                    <FloatingLabel
                                        controlId="formBasicPassword"
                                        label="Password"
                                        className="mb-3"
                                    >
                                        <Form.Control ref={passwordRef} type="password" placeholder="Password" />
                                    </FloatingLabel>
                                    <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                        <Form.Check type="checkbox" label="Remember Me" />
                                    </Form.Group>
                                    <p className='text-center fw-bold my-4'>
                                        Forgot Your Password? <Link to={'/login'} onClick={resetPassword}>Reset Password</Link>
                                    </p>

                                    <Button variant="primary" type="submit" className='w-100 fs-5 fw-bold'>Login</Button>
                                    <p className='text-center fw-bold my-4'>
                                        Don't Have An Account? <Link to='/sign-up'>Create One</Link>
                                    </p>
                                    <p className='text-center text-danger fw-bold'>
                                        {error?.message}
                                    </p>
                                </Form>
                            </Card.Body>
                        </Card>
                        <Card className='border-0 mx-auto'style={{maxWidth:'450px'}}>
                            <Card.Body className='text-center'>
                                <Button onClick={()=>signInWithGoogle()}><FontAwesomeIcon icon={faGoogle}/> Continue With Google</Button>
                            </Card.Body>
                        </Card>
                    </div>
            </Container>
            <ToastContainer/>
        </div>
    );
};

export default Login;